import { useState } from 'react';
import { auditService } from '../../services/auditService';

/**
 * Dialog to send a recount request to the auditors' phones.
 * prefill: { location_code, ean, product_name } (all optional).
 * locations: location master codes for suggestions.
 */
function RecountForm({ auditId, prefill = {}, locations = [], onClose, onSent }) {
  const [location, setLocation] = useState(prefill.location_code || '');
  const [ean, setEan] = useState(prefill.ean || '');
  const [note, setNote] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    if (!location.trim() && !ean.trim()) {
      setError('Give the rack / location tag, the EAN, or both.');
      return;
    }
    setSending(true);
    try {
      const created = await auditService.createRecount(auditId, {
        location_code: location.trim(),
        ean: ean.trim(),
        product_name: prefill.ean && prefill.ean === ean.trim() ? prefill.product_name : undefined,
        note: note.trim(),
      });
      onSent?.(created);
      onClose();
    } catch (err) {
      setError(err.message);
      setSending(false);
    }
  };

  return (
    <div className="live-modal" role="dialog" aria-modal="true" aria-label="Request a recount">
      <div className="live-modal__backdrop" onClick={sending ? undefined : onClose} />
      <form className="live-modal__panel" onSubmit={submit}>
        <header className="live-modal__header">
          <h2>Request a recount</h2>
          <button type="button" onClick={onClose} aria-label="Close" disabled={sending}>
            ×
          </button>
        </header>
        <p className="live-muted">
          The auditors on this schedule get the request on their phones straight away. You can
          follow it on the Recounts tab.
        </p>
        {error ? <p className="compare-error">{error}</p> : null}
        <label className="live-field">
          Rack / location tag
          <input
            value={location}
            onChange={(event) => setLocation(event.target.value)}
            list="recount-location-options"
            placeholder="e.g. LOC-GOND-G04"
            autoFocus={!prefill.location_code}
          />
          <datalist id="recount-location-options">
            {locations.slice(0, 2000).map((code) => (
              <option key={code} value={code} />
            ))}
          </datalist>
        </label>
        <label className="live-field">
          EAN (optional)
          <input
            value={ean}
            onChange={(event) => setEan(event.target.value)}
            placeholder="Item to recount"
            inputMode="numeric"
          />
          {prefill.product_name && prefill.ean === ean.trim() ? (
            <small className="live-muted">{prefill.product_name}</small>
          ) : null}
        </label>
        <label className="live-field">
          Note for the auditor
          <textarea
            rows={3}
            value={note}
            onChange={(event) => setNote(event.target.value)}
            placeholder="e.g. Please verify AirPods Pro stock; 1 unit was moved to the backroom display."
            autoFocus={Boolean(prefill.location_code)}
          />
        </label>
        <footer className="live-modal__footer">
          <button type="button" className="compare-button compare-button--ghost" onClick={onClose} disabled={sending}>
            Cancel
          </button>
          <button type="submit" className="compare-button live-button--warn" disabled={sending}>
            {sending ? 'Sending…' : 'Send recount request'}
          </button>
        </footer>
      </form>
    </div>
  );
}

export default RecountForm;
